const Select = window.ELEMENT.Select;

Select.props.popperOptions = {
  default() {
    return {
      gpuAcceleration: false
    };
  }
};

let render = Select.render;
Select.render = function(...args) {
  let res = render.apply(this, args);
  let ElSelectDropdown = res.children[2].componentOptions.children[0];
  ElSelectDropdown.componentOptions.propsData.popperOptions = this.popperOptions;

  dsf.deepForEach(res, node => {
    if (node.tag?.endsWith('ElTag') && !node.data.attrs.title) {
      let span = node.componentOptions.children[0];
      let text = span?.children[0];
      if (text?.text) {
        node.data.attrs.title = text.text;
      }
    }
  }, {
    children: it => {
      if (it.children) return it.children;
      if (it.componentOptions) return it.componentOptions.children;
      return null;
    }
  });
  return res;
}
// Select.methods.handleQueryChange=function(val){
//   if (this.previousQuery === val || this.isOnComposition) return;
//   if (this.previousQuery === null && (typeof this.filterMethod === "function" || typeof this.remoteMethod === "function")) {
//     this.previousQuery = val;
//     return;
//   }
//   this.previousQuery = val;
//   this.$nextTick(() => {
//     if (this.visible) this.broadcast("ElSelectDropdown", "updatePopper");
//   });
//   this.hoverIndex = -1;
//   if (this.multiple && this.filterable) {
//     this.$nextTick(() => {
//       const length = this.$refs.input.value.length * 15 + 20;
//       this.inputLength = this.collapseTags ? Math.min(50, length) : length;
//       this.managePlaceholder();
//       this.resetInputHeight();
//     });
//   }
//   if (this.remote && typeof this.remoteMethod === "function") {
//     this.hoverIndex = -1;
//     this.remoteMethod(val);
//   } else if (typeof this.filterMethod === "function") {
//     this.filterMethod(val);
//     // this.broadcast("ElOption", "queryChange", val);
//     this.broadcast("ElOptionGroup", "queryChange");
//   } else {
//     this.filteredOptionsCount = this.optionsCount;
//     this.broadcast("ElOption", "queryChange", val);
//     this.broadcast("ElOptionGroup", "queryChange");
//   }
//   if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
//     this.checkDefaultFirstOption();
//   }
// }